module.exports = function() {
    $('.category-marketing-slot').each(function() {
        var $categoryMarketingSlot = $(this);
        if ($categoryMarketingSlot.children().length === 0) {
            $categoryMarketingSlot.addClass('hide');
        }
    });
};
